import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';

const RefundModal = ({
    show,
    handleClose,
    selectedTransaction,
    selectedOption,
    handleOptionSelect,
    amount,
    setAmount,
    realizarDevolucion,
    realizarDevolucionParcial
}) => {
    return (
        <Modal show={show} onHide={handleClose} dialogClassName="modal-dialog-centered">
            <Modal.Header closeButton>
                <Modal.Title className='fw-bold' style={{ color: "#3E4144", fontSize: '20px', fontFamily: 'Montserrat, sans-serif' }}>
                    ¿Qué tipo de devolución desea realizar?
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex justify-content-around mb-3">
                    <Button
                        variant={selectedOption === 'total' ? 'success' : 'outline-secondary'}
                        onClick={() => handleOptionSelect('total')}
                        className="fw-bold"
                        style={{ borderRadius: '20px', padding: '10px 20px' }}
                    >
                        Devolución Total
                    </Button>
                    <Button
                        variant={selectedOption === 'parcial' ? 'success' : 'outline-secondary'}
                        onClick={() => handleOptionSelect('parcial')}
                        className="fw-bold"
                        style={{ borderRadius: '20px', padding: '10px 20px' }}
                    >
                        Devolución Parcial
                    </Button>
                </div>

                {selectedOption === 'parcial' && (
                    <Form.Group controlId="partialAmount">
                        <Form.Label className="fw-bold" style={{ color: "#3E4144", fontSize: '16px', fontFamily: 'Montserrat, sans-serif' }}>
                            Ingrese el monto a devolver:
                        </Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Monto"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                        />
                    </Form.Group>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={handleClose}
                    className="fw-bold"
                    style={{ borderRadius: '20px' }}
                >
                    Cancelar
                </Button>
                <Button
                    disabled={!selectedOption}
                    variant="success"
                    onClick={() => {
                        if (selectedOption === 'total') {
                            realizarDevolucion();
                        } else {
                            realizarDevolucionParcial();
                        }
                        handleClose();
                    }}
                    className="fw-bold"
                    style={{ borderRadius: '20px' }}
                >
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RefundModal;
